export const MOBILE = 'MOBILE_PHONE';
export const DESKTOP = 'DESKTOP';
export const prodEndpoint =
    'https://bex.us-west-2.test.customer-experience.expediagroup.com/graphql';
export const devEndpoint =
    'https://bex.us-west-2.test.customer-experience.expediagroup.com/graphql';
export const defaultDuaId = '41806f84-8fc3-4f37-afa1-0748621e8cf9';
export const pathName = {
    ENTRY: '/node/home',
    SEARCH_RESULTS: '/serp',
    POST_BOOKING: '/traveler/th',
    FEATURES: '/traveler/th',
    CONFIRMATION: '/traveler/th',
};
export const siteIds = {
    homeaway_us: 9001001,
    vrbo: 9001001,
    homeaway_ca: 9001003,
    homeaway_cafr: 9001004,
    homeaway_mx: 9001005,
    homeaway_uk: 9001006,
    homeaway_at: 9001008,
    homeaway_es: 9001009,
    homeaway_it: 9001011,
    abritel: 9001013,
    homeaway_pt: 9001015,
    homeaway_nl: 9001016,
    homeaway_fi: 9001017,
    homeaway_pl: 9001018,
    homeaway_gr: 9001019,
    homeaway_de: 9001020,
    homeaway_au: 9001024,
    homeaway_no: 9001025,
    homeaway_dk: 9001026,
    homeaway_se: 9001027,
    homeaway_br: 9001028,
    homeaway_nz: 9001029,
    homeaway_sg: 9001031,
    homeaway_jp: 9001032,
    bookabach: 9001043,
    stayz: 9001044,
};
